(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  (function() {
    var phoneViewport = window.matchMedia('(max-width: 749px)');

    function initializeMobileDisclosures() {
      document.querySelectorAll('.wm-mobile-disclosure').forEach(function(details) {
        if (details.dataset.wmDisclosureBound === 'true') return;
        details.dataset.wmDisclosureBound = 'true';
        details.open = !phoneViewport.matches;

        function revealLinkedFinder() {
          if (details.id && window.location.hash === '#' + details.id) {
            details.open = true;
          }
        }

        revealLinkedFinder();
        window.addEventListener('hashchange', revealLinkedFinder);
        phoneViewport.addEventListener('change', function() {
          if (details.isConnected) details.open = !phoneViewport.matches;
        });
      });
    }

    initializeMobileDisclosures();
    document.addEventListener('shopify:section:load', initializeMobileDisclosures);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wm-product-recommendations')) {
    customElements.define('wm-product-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded || Number(this.dataset.count) >= 4) return;
        this.dataset.loaded = 'true';
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          observer.disconnect();
          this.loadRecommendations();
        }, { rootMargin: '400px' });
        observer.observe(this);
        this.observer = observer;
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
      async loadRecommendations() {
        try {
          const response = await fetch(this.dataset.url);
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const replacement = html.querySelector('wm-product-recommendations');
          if (!replacement || Number(replacement.dataset.count) <= Number(this.dataset.count)) return;
          this.querySelector('[data-related-content]').replaceChildren(...replacement.querySelector('[data-related-content]').childNodes);
          this.dataset.count = replacement.dataset.count;
        } catch {
          return;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
